/**
 * Test IDs for QA automation.
 */
export const testIds = {
  imagePreviewDialogClose: "image-preview-dialog-close",
  imagePreviewDialogPreviousImage: "image-preview-dialog-previous-image",
  imagePreviewDialogNextImage: "image-preview-dialog-next-image",
  imagePreviewDialogDownloadImage: "image-preview-dialog-download-image",
} as const;
